<script setup>
import { ref, onMounted } from 'vue';
import { Head, Link, usePage } from '@inertiajs/vue3';
import axios from 'axios';

const props = defineProps({
    user: Object
});

const form = ref({
    name: '',
    email: '',
    phone: '',
    location: '',
    password: '',
    password_confirmation: ''
});

const loading = ref(false);
const saving = ref(false);

const initForm = () => {
    // User data passed from controller via props
    if (props.user) {
        form.value.name = props.user.name;
        form.value.email = props.user.email;
        form.value.phone = props.user.phone || '';
        form.value.location = props.user.location || '';
    }
};

const submitForm = async () => {
    saving.value = true;
    try {
        const response = await axios.put('/admin/profile/update', form.value);
        if (response.data.status === 'success') {
            alert(response.data.message);
            // Reset password fields
            form.value.password = '';
            form.value.password_confirmation = '';
        } else if (response.data.status === 'info') {
            alert(response.data.message);
        }
    } catch (error) {
        if (error.response?.data?.errors) {
            const errors = Object.values(error.response.data.errors).flat();
            alert(errors.join('\n'));
        } else {
            alert('Terjadi kesalahan saat memperbarui profil');
        }
    } finally {
        saving.value = false;
    }
};

onMounted(() => {
    initForm();
});
</script>

<template>
    <Head title="Profil Saya" />

    <div class="container-full">
        <div class="content-header">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-block">
                    <h4 class="page-title">Profil Saya</h4>
                    <div class="d-inline-block align-items-center">
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <Link href="/admin/dashboard"><i class="mdi mdi-home-outline"></i></Link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">Profil</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="row">
                <div class="col-xl-4 col-lg-5">
                    <div class="card text-center">
                        <div class="card-body">
                            <img src="/back/images/avatar/avatar-13.png" class="rounded-circle avatar-lg img-thumbnail mb-3" alt="Profile Avatar">
                            <h4 class="mb-0">{{ props.user?.name }}</h4>
                            <p class="text-muted">{{ props.user?.email }}</p>
                            <div class="text-start mt-3">
                                <p class="text-muted mb-2 font-13"><strong>Phone :</strong> <span class="ms-2">{{ props.user?.phone || '-' }}</span></p>
                                <p class="text-muted mb-2 font-13"><strong>Location :</strong> <span class="ms-2">{{ props.user?.location || '-' }}</span></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xl-8 col-lg-7">
                    <div class="card">
                        <div class="card-body">
                            <h4 class="header-title mb-3">Edit Profil</h4>
                            <form @submit.prevent="submitForm">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-name" class="form-label">Nama Lengkap <span class="text-danger">*</span></label>
                                        <input type="text" id="profile-name" name="name" v-model="form.name" class="form-control" autocomplete="name" required>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-email" class="form-label">Email <span class="text-danger">*</span></label>
                                        <input type="email" id="profile-email" name="email" v-model="form.email" class="form-control" autocomplete="email" required>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-phone" class="form-label">No. Telepon</label>
                                        <input type="text" id="profile-phone" name="phone" v-model="form.phone" class="form-control" autocomplete="tel">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-location" class="form-label">Lokasi</label>
                                        <input type="text" id="profile-location" name="location" v-model="form.location" class="form-control" autocomplete="address-level2">
                                    </div>
                                </div>
                                <hr>
                                <h5 class="mb-3">Ganti Password <small class="text-muted">(Kosongkan jika tidak ingin mengubah)</small></h5>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-password" class="form-label">Password Baru</label>
                                        <input type="password" id="profile-password" name="password" v-model="form.password" class="form-control" autocomplete="new-password">
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="profile-password-confirm" class="form-label">Konfirmasi Password</label>
                                        <input type="password" id="profile-password-confirm" name="password_confirmation" v-model="form.password_confirmation" class="form-control" autocomplete="new-password">
                                    </div>
                                </div>

                                <div class="d-flex justify-content-end">
                                    <button type="submit" class="btn btn-primary" :disabled="saving">
                                        <i v-if="saving" class="fa fa-spinner fa-spin me-1"></i> Simpan Perubahan
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
